<template>
  <div class="page issues-chrome-container">
    <LayoutContainer>
      <div class="page-header">
        <h1 class="title"><i class="fas fa-layer-group icon"></i> Issues</h1>
        <div class="filter">
          <FilterDate :defaultFilter="'forever'" :disabledRangeDateKey="disabledDate" />
        </div>
      </div>
      <div class="issues-summary-tab mb-4">
        <router-link
          :to="'summary'"
          class="tab-item no-link"
          :class="{ 'active': isSummaryUrl }" >
          Summary
        </router-link>
        <router-link
          :to="'list'"
          class="tab-item no-link"
          :class="{ 'active': isListUrl }" >
          Issue List
        </router-link>
      </div>
      <div class="issues-chrome">
        <router-view
          :issuesData="issuesData"
          :issuesList="issuesList"
          :issuesDataLoading="state.issuesDataLoading"
          :issuesListLoading="state.issuesListLoading" />
        <div class="text-danger" v-if="error">
          {{ error }}
        </div>
      </div>
    </LayoutContainer>
  </div>
</template>

<script>
import _ from 'lodash';
import { getTotalIssues, getIssuesList } from '@/issues/api';
import generateLink from '@/utils/generateLink';

import LayoutContainer from '@/layout/LayoutContainer.vue';
import FilterDate from '@/components/FilterDate.vue';

export default {
  mixins: [generateLink],
  components: {
    LayoutContainer,
    FilterDate,
  },
  data() {
    return {
      preLoaderOptions: { height: '500', enabledTwoColumns: true },
      disabledDate: ['forever', 'today', 'last7days', 'last30days', 'custom'],
      dateFilter: null,
      issuesData: null,
      issuesList: null,
      error: null,
      state: {
        issuesDataLoading: true,
        issuesListLoading: true,
      },
    };
  },
  computed: {
    path() {
      const paths = _.split(this.$route.path, '/');
      const { length } = paths;
      return paths[length - 1];
    },
    isSummaryUrl() {
      return this.path === 'summary';
    },
    isListUrl() {
      return this.path === 'list';
    },
  },
  async created() {
    let filter = this.generateQuery(this.$route.query);
    if (_.isEmpty(filter)) {
      filter = { range: 'last24hours' };
    } else {
      filter = this.generateQuery(this.$route.query);
    }
    this.loadTotalIssues(filter);
    this.loadIssuesList(filter);
  },
  methods: {
    async loadTotalIssues(filter) {
      try {
        const response = await getTotalIssues(filter);
        this.issuesData = response.data;
      } catch (e) {
        this.error = e;
      }
      this.state.issuesDataLoading = false;
    },
    async loadIssuesList(filter) {
      try {
        const response = await getIssuesList(filter);
        this.issuesList = response.data;
      } catch (e) {
        this.error = e;
      }
      this.state.issuesListLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';

.tab-item {
  padding: $spacer * 0.5 $spacer * 0.75;
  border-radius: 3px;
  margin: 0 $spacer * 0.25;
  cursor: pointer;
  background-color: white;
  // color: lighten($body-color, 5%);
  color: black;
  border: 1px solid #eeeeee;

  &.active,
  &:hover {
    border-color: $primary;
    color: $primary;
  }
  &:first-child {
    margin-left: 0;
  }
}
</style>
